import { Helmet } from 'react-helmet';
import { connect } from 'react-redux';

import { favicons } from 'assets/favicons';
import { IStoreEnvironment } from 'store/store';
import { DateTime } from 'luxon';

interface IHtmlHeadProps {
  environment: IStoreEnvironment;
}

const HtmlHead = (props: IHtmlHeadProps) => {
  const { environment } = props;
  const env = environment.REACT_APP_ENV!;

  let favicon = favicons.production;

  const titleTemplate = [`busybusy`, `%s`];
  const titleTemplateDelimiter = ' - ';

  if (env !== 'production') {
    const version = environment.REACT_APP_VERSION!;
    const buildDate = DateTime.fromISO(environment.REACT_APP_BUILDDATE).toISODate()!;

    titleTemplate.unshift(`${version}@${buildDate}`);
    favicon = favicons[env];
  }

  return (
    <Helmet titleTemplate={titleTemplate.join(titleTemplateDelimiter)} defaultTitle="busybusy">
      <link rel="shortcut icon" href={favicon} />
    </Helmet>
  );
};

const mapStateToProps = ({ environment }: IHtmlHeadProps) => {
  return { environment };
};

export default connect(mapStateToProps)(HtmlHead);
